// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"408":"cc066f0f","932":"4f034e44"}[chunkId] + ".css";
};